import { css } from "lit";

export const styles = css`
  :host {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  /* Unified layout - CSS Grid with named areas */
  .layout-container {
    display: grid;
    grid-template:
      " actions actions  " auto
      " main    secondary" 1fr
      / 1fr 1fr;
    gap: var(--sds-size-space-600);
    height: 100%;
    width: 100%;
    min-height: 0;
  }

  /* When no secondary content: single column layout */
  .layout-container.no-secondary {
    grid-template:
      "actions" auto
      "main" 1fr
      / 1fr;
  }

  .layout-container.no-secondary content-container:nth-of-type(2) {
    display: none;
  }

  /* Actions Area - Only action buttons now */
  .actions {
    grid-area: actions;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: var(--sds-size-space-400);
  }

  /* Content container positioning in grid */
  content-container:nth-of-type(1) {
    grid-area: main;
  }

  content-container:nth-of-type(2) {
    grid-area: secondary;
  }

  /* Responsive Design */
  @media (max-width: 1024px) {
    /* Convert grid to single column for mobile */
    .layout-container {
      grid-template:
        "actions" auto
        "main" 1fr
        / 1fr;
      gap: var(--sds-size-space-800);
    }

    /* Hide secondary content-container on mobile */
    content-container:nth-of-type(2) {
      display: none;
    }
  }
`;
